import DeliveryRoutesIndex from './Index.vue';

export const routes = [
  {
    path: 'rotas',
    name: 'talkvia_delivery_routes',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: DeliveryRoutesIndex,
  },
];
